import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

class EmptyState extends Component {
	shouldComponentUpdate = ({
		message,
		allowAssign,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(message, lastProps.message)
			|| !isEqual(allowAssign, lastProps.allowAssign)
		);
	}

	render() {
		const {
			message,
		} = this.props;

		return (
			<div className="empty-state">
				<div className="empty-state__content">
					<p>{ message }</p>
				</div>
			</div>
		);
	}
}

EmptyState.propTypes = {
	allowAssign : PropTypes.bool,
	message     : PropTypes.any,

};

EmptyState.defaultProps = {
	allowAssign : true,
	message     : '',
};

export default EmptyState;
